import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { formatImage } from '@src/common/formatImage';
import { Player } from '@ifeng-fe/three_terminal/es/pc/video';

class ImageSwiper extends PureComponent {

    static propTypes = {
        content: PropTypes.array
    }

    state = {
        videoIndex: 0
    }

    setVideoIndex = (index) => {
        this.setState({
            videoIndex: index
        });
    }

    render() {
        const { content } = this.props;
        const { videoIndex } = this.state;

        return (
            <div className={styles.videoList}>
                <Player
                    key={videoIndex}
                    videoConfig={{
                        title: content[videoIndex].title,
                        posterUrl: content[videoIndex].posterUrl,
                        videoPlayUrl: content[videoIndex].videoPlayUrl
                    }}
                    playermsg={{
                        // 播放器宽
                        width: 580,
                        // 播放器高
                        height: 457,
                        // 是否自动播放
                        autoPlay: false,
                        // 是否显示播放控件
                        controls: true,
                    }}
                />
                <div className={styles.list}>
                    {
                        content.map((item, index) => {
                            return (
                                <div key={index} onClick={() => this.setVideoIndex(index)}>
                                    {item.title}
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        );
    }
}

export default ImageSwiper;
